module.exports = __webpack_public_path__ + "img/copy.5fc51aab.svg";